import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ModalValidarDocumentoComponent } from '../modal-descarga-certificado/modal-validar-documento.component';

@Component({
  selector: 'app-descargas-token',
  template: `
    <div class="download-container">
      <div class="overlay">
        <div class="content">
          <img src="assets/imagenes/logo-coomeva.webp" class="logo" alt="Coomeva" />

          <h1>Descarga segura de certificados</h1>
          <p>Para obtener su documento, haga clic en el botón de abajo e ingrese su número de identificación.</p>
          
          <button 
            mat-raised-button 
            class="btn-download-custom"  (click)="abrirModalDescarga()"
            [disabled]="!token">
            <mat-icon>download</mat-icon>
            DESCARGAR
        </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./descargas-token.component.css']
})
export class DescargasTokenComponent implements OnInit {
  token = '';
  modalAbierto = false;

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') || '';

    if (!this.token) {
      console.error('No se encontró un token válido en la URL.');
    }
  }
  
  abrirModalDescarga(): void {
    if (!this.token) return;

    const ref = this.dialog.open(ModalValidarDocumentoComponent, {
      width: '520px',
      disableClose: true,
      panelClass: 'modal-certificados-custom',
      data: {
        token: this.token,
        tipo: 'Certificado'
      }
    });

    this.modalAbierto = true;

    ref.afterClosed().subscribe(() => {
      this.modalAbierto = false;
    });
  }
}